import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, from, defer } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Auth0Service } from '../services/auth0.service';

export const auth0Interceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const auth0Service = inject(Auth0Service);

  // Only add auth header to our API calls
  if (shouldAddToken(req.url)) {
    return defer(() => auth0Service.getAccessToken()).pipe(
      switchMap((token) => {
        if (!token) {
          console.error('No access token available for request:', req.url);
          return throwError(
            () =>
              new HttpErrorResponse({
                error: 'No access token available',
                status: 401,
                statusText: 'Unauthorized',
              })
          );
        }

        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
        return next(authReq);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.error('Authentication failed for request:', req.url);
          // Redirect to login if token is invalid/expired
          auth0Service.redirectToAuth0Login();
        }
        return throwError(() => error);
      })
    );
  }

  return next(req);
};

function shouldAddToken(url: string): boolean {
  // Add token to API calls to your backend
  // Adjust this condition based on your API URL pattern

  // Exclude public endpoints that don't require authentication
  if (url.includes('/request-password-reset')) {
    return false;
  }

  return (
    url.includes('/api/data/') ||
    url.includes('/api/migration/') ||
    url.includes('/api/aidvice/') ||
    url.includes('/user-management/')
  );
}
